import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Status, Asset, Learnspace } from '@shared/models';
import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { filter } from 'rxjs/operators';
import { AssetType } from '@shared/models/assetType.model';

@Component({
  selector: 'learnspace-edit-form',
  templateUrl: './learnspace-edit-form.component.html',
  styleUrls: ['./learnspace-edit-form.component.scss']
})
export class LearnspaceEditFormComponent implements OnInit {
  @Input() learnspace: Learnspace;
  @Input() hubId: string;
  @Input() isTabMode: boolean;
  @Output() learnspaceChange = new EventEmitter<Learnspace>();
  lsForm: FormGroup;
  asset: Asset;
  fileManager: MatDialogRef<FileManagerComponent>;
  title: string;
  statusList = Object.values(Status);
  assetSize: { width: string; height: string } = { width: '179px', height: '100px'};

  constructor(private _dialog: MatDialog) {
    this.lsForm = new FormGroup({
      title: new FormControl('', { validators: [Validators.required, Validators.maxLength(50)], updateOn: 'blur' }),
      description: new FormControl('', { updateOn: 'blur' }),
      status: new FormControl('draft'),
      postermedia_id: new FormControl('', { validators: [Validators.required], updateOn: 'change' }),
      hub_id: new FormControl('')
    });
  }

  ngOnInit(): void {
    if (this.isTabMode) {
      this.assetSize.width = '400px';
      this.assetSize.height = '225px';
    }
    if (this.learnspace) {
      this.lsForm.reset(this.learnspace);
      this.asset = this.learnspace.postermedia;
    } else {
      this.lsForm.controls['hub_id'].setValue(this.hubId);
    }

    this.lsForm.valueChanges.subscribe((value) => {
      this.learnspaceChange.emit({ ...this.learnspace, ...value });
    });
  }

  newPoster(asset: Asset): void {
    this.asset = asset;
    if (this.learnspace) {
      this.learnspace.postermedia = this.asset;
    }
    this.lsForm.controls.postermedia_id.setValue(asset.id);
  }
  onOpenFileManager(): void {
    this.fileManager = this._dialog.open(FileManagerComponent, {
      panelClass: 'learnspace-theme',
      data: {
        title: 'Poster Image',
        type: AssetType.i2D,
        openOnTab: 0,
        learnspaceId: this.learnspace?.id
      },
      id: 'file-manager'
    });
    this.fileManager
      .afterClosed()
      .pipe(filter((event) => event !== undefined))
      .subscribe((val) => {
        this.newPoster(val);
      });
  }
}
